/* eslint-disable jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useEffect, useState } from 'react';
import { Checkbox, DatePicker, DateRangePicker } from '@americanexpress/dls-react';
import OverflowItem from '../../../OverflowItem';
import DatePickerInput from './DatePickerInput';

function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}

function formatDate(date) {
  return [
    date.getFullYear(),
    padTo2Digits(date.getMonth() + 1),
    padTo2Digits(date.getDate()),
  ].join('-');
}

const isStringDateValid = (dateString) => import(/* webpackChunkName: 'moment' */ 'moment').then(
  ({ default: moment }) => moment(dateString, 'MM/DD/YYYY', true).isValid()
);

const DateRangePickerFilterComponent = React.memo((props) => {
  const {
    header, filters, colIdx, filter, setFilter, onKeyPress, tableNm, isDisable,
  } = props;

  const [dateRangePicker, setDateRangePicker] = useState(false);
  const [labelComponentClicked, setLabelComponentClicked] = useState(null);
  const [rangeDateStatus, setRangeDateStatus] = useState('default');
  const [datePickerValue, setDatePickerValue] = useState('');
  const [datePickerStatus, setDatePickerStatus] = useState('default');

  const [dates, setDates] = React.useState({
    start: '',
    end: '',
    max: header?.allowFutureDates ? '' : formatDate(new Date()),
  });
  const ids = {
    start: `${tableNm}-${header?.id}-drpicker-start`,
    end: `${tableNm}-${header?.id}-drpicker-end`,
  };

  const saveFilter = (fil) => {
    const newFilters = [...filters];
    newFilters[colIdx] = fil;
    setFilter(newFilters);
    onKeyPress({
      key: 'Enter',
      filters: newFilters,
    });

    console.log('saveFilter');

    console.log(datePickerValue);

    if (!fil || fil === '') {
      setDates((oldState) => ({
        ...oldState,
        start: '',
        end: '',
        min: '',
      }));
      setDatePickerValue('');
    } else {
      setLabelComponentClicked(false);
    }
  };

  useEffect(() => {
    if (dates.start && dates.end) {
      const start = new Date(dates.start);
      const end = new Date(dates.end);
      if (start.valueOf() <= end.valueOf()) {
        setRangeDateStatus('default');
        isStringDateValid(dates.start).then((startDateValid) => {
          isStringDateValid(dates.end).then((endDateValid) => {
            // Check to make sure that manually inputted date is not over the allowed dates
            if (startDateValid && endDateValid) {
              saveFilter(`${dates.start}-${dates.end}`);
            }
          });
        });
      } else {
        setRangeDateStatus('error');
      }
    }
  }, [dates]);

  const onRangeDateChange = (event, date) => {
    let result = true;
    if (!date?.dateString?.match(/[^\d/]/)) {
      setRangeDateStatus('default');
      const exceedsTodaysDate = (LocalDate) => {
        const selectedDate = new Date(new Date(LocalDate).setHours(0, 0, 0));
        const todaysDate = new Date(new Date().setHours(0, 0, 0));
        return selectedDate.valueOf() > todaysDate.valueOf();
      };

      if (!header?.allowFutureDates && exceedsTodaysDate(date.dateString)) {
        setRangeDateStatus('error');
        result = false;
      }

      // eslint-disable-next-line no-unused-expressions
      if (event?.target?.name === ids.start) {
        setDates((oldState) => ({
          ...oldState,
          start: date.invalid ? '' : date.dateString,
          end: '',
          min: date.invalid ? '' : formatDate(new Date(date.dateString)),
        }));
      } else {
        setDates((oldState) => ({
          ...oldState,
          end: date.invalid ? '' : date.dateString,
          min: date.invalid ? oldState?.min : '',
        }));
      }
    } else {
      result = false;
    }
    return result;
  };

  const overflowStyle = {
    '.overFlowPopUpVisible': {
      background: 'white',
      border: 'solid 1px',
      borderRadius: '6px',
      borderColor: 'lightgrey',
      padding: '0.5rem',
      height: dateRangePicker ? '125px !important' : '125px !important',
      width: dateRangePicker ? '300px !important' : '300px !important',
    },
  };

  const onDateChange = (event, date) => {
    setDatePickerStatus('default');
    if (!date?.dateString?.match(/[^\d/]/)) {
      setDatePickerValue(date?.dateString);
      isStringDateValid(date?.dateString).then((result) => {
        if (result) {
          // Check to make sure that manually inputted date is not over the allowed dates
          if (!header?.allowFutureDates) {
            const selectedDate = new Date(new Date(date.dateString).setHours(0, 0, 0));
            const todaysDate = new Date(new Date().setHours(0, 0, 0));
            if (selectedDate.valueOf() > todaysDate.valueOf()) {
              setDatePickerStatus('error');
              saveFilter('');
              return;
            }
          }
          saveFilter(date?.dateString);
        }
      });
    }
  };

  useEffect(() => {
    const getDate = (date) => ({ dateString: date });
    if (filter !== '') {
      // Saved filter validation to ensure accurate dates
      if (filter?.includes('-')) {
        setDateRangePicker(true);
        if (!dates.start || !dates.end) {
          const startDate = filter.split('-')[0];
          const endDate = filter.split('-')[1];
          let result = null;
          result = onRangeDateChange({ target: { name: ids.start } }, getDate(startDate));
          if (!result) {
            console.log('Didnt pass first pass');
            saveFilter('');
          }
          result = onRangeDateChange(undefined, getDate(endDate));
          if (!result) {
            console.log('Didnt pass second pass');
            saveFilter('');
          }
        }
      } else if (!datePickerValue) {
        onDateChange(undefined, getDate(filter));
      }
    } else {
      console.log('saveFilter #2');
      setDatePickerValue('');
      setDates((oldState) => ({
        ...oldState,
        start: '',
        end: '',
        min: '',
      }));
    }
  }, [filter]);

  return (
    <div>
      <OverflowItem
        id={`${tableNm}-${header?.id}-overflowItem`}
        theme={overflowStyle}
        isLabelComponentClicked={labelComponentClicked}
        isDisable={isDisable}
        labelComponent={(
          <DatePickerInput
            id={`${tableNm}-${header?.id}-datePickerInput`}
            value={filter}
            placeholder={header?.label}
            calendarClosed={false}
            onButtonClick={() => {}}
            calendarButtonLabel={`${tableNm}-${header?.id}-datePickerCalenderButton`}
            dateIconFilled={true}
            isDisable={isDisable}
          />
)}
      >
        <div>
          <div
            id={`${tableNm}-${header?.id}-rangePickerCheckboxContainer`}
            className="flex"
            style={{ justifyContent: 'space-between' }}
          >
            <Checkbox
              checked={dateRangePicker}
              id={`${tableNm}-${header?.id}-rangePickerCheckbox`}
              label={<span>Add Date Range</span>}
              name={`${tableNm}-${header?.id}-rangePickerCheckboxSelection`}
              onChange={() => setDateRangePicker(!dateRangePicker)}
            />
            <a
              id={`${tableNm}-${header?.id}-clearDateFilter`}
              onClick={() => saveFilter('')}
            >Clear
            </a>
          </div>
        </div>
        <div>
          {dateRangePicker
            ? (
              <DateRangePicker
                dates={dates}
                ids={ids}
                labels={{
                  end: 'End Date',
                  endCalendarButton: `${tableNm}-${header?.id}-drpicker-end-button`,
                  nextMonth: `${tableNm}-${header?.id}-drpicker-nextMonth`,
                  previousMonth: `${tableNm}-${header?.id}-drpicker-prevMonth`,
                  start: 'Start Date',
                  startCalendarButton: `${tableNm}-${header?.id}-drpicker-start-button`,
                }}
                placeholder="MM/DD/YYYY"
                status={rangeDateStatus}
                onChange={onRangeDateChange}
                minDays={1}
              />
            ) : (
              <DatePicker
                id={`${tableNm}-${header?.id}-drpicker`}
                date={datePickerValue}
                placeholder="MM/DD/YYYY"
                buttonLabels={{
                  calendarButton: `${tableNm}-${header?.id}-drpicker-button`,
                  previousMonth: `${tableNm}-${header?.id}-drpicker-prevMonth`,
                  nextMonth: `${tableNm}-${header?.id}-drpicker-nextMonth`,
                }}
                describedBy={`${tableNm}-${header?.id}-drpicker-input`}
                status={datePickerStatus}
                onDateChange={onDateChange}
                maxDate={header?.allowFutureDates ? '' : formatDate(new Date())}
              />
            )}
        </div>

      </OverflowItem>
    </div>
  );
});

export default DateRangePickerFilterComponent;
